/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Heading, Stack, Text, Divider } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { map, get, set } from 'lodash';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import Navigation from 'modules/app/shopify/navigation';
import AnnotatedSection from 'components/annotated-section';
import Card from 'components/card';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import AnnotatedSectionSkeleton from 'components/skeleton-loader/annotated-section-skeleton';
import aecSdk from 'lib/app-ec-sdk';
import cecSdk from 'lib/customer-ec-sdk';
import Notice from 'components/notice';
import { successNotice, errorNotice } from 'state/notices/actions';
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import FormSelect from 'components/forms/form-select';
import Icon from 'components/icon';
import { requestConnection, saveConnection } from 'state/connections/actions';
import { requestConnectionTypes } from 'state/connection-types/actions';
import JumpingDots from 'components/jumping-dots';
import { getCurrentUsername } from 'state/current-user/selectors';
import { getAllConnectionTypes } from 'state/connection-types/selectors';
import SelectResources from './select-resources';
import ConnectionInputRow from 'modules/dashboard/connections/connection-input-row';

/**
 * Style dependencies
 */
import './styles.scss';

const CreateConnection = ({ callback, accessToken, shopUrl, apiKey, sharedSecret, ...props }) => {
    const [saving, setSaving] = useState(false);
    const [requesting, setRequesting] = useState(true);
    const [error, setError] = useState(false);
    const [appValues, setAppValues] = useState({});
    const [values, setValues] = useState({});
    const [copyTokenSuccess, setCopyTokenSuccess] = useState('');
    const [copyUrlSuccess, setCopyUrlSuccess] = useState('');
    const [weblinkGroups, setWeblinkGroups] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [defaultConnectionType, setDefaultConnectionType] = useState(null);
    const [defaultResources, setDefaultResources] = useState([]);
    const [onChangedConnectionType, setOnChangedConnectionType] = useState(null);

    useEffect(() => {
        loadData();
        props.requestConnectionTypes();
        setOnChangedConnectionType(defaultConnectionType);
    }, []);

    const copyTokenToClipBoard = async copyMe => {
        try {
            await navigator.clipboard.writeText(copyMe);
            setCopyTokenSuccess('Copied!');
        } catch (err) {
            setCopyTokenSuccess('Failed to copy!');
        }
    };

    const copyUrlToClipBoard = async copyMe => {
        try {
            await navigator.clipboard.writeText(copyMe);
            setCopyUrlSuccess('Copied!');
        } catch (err) {
            setCopyUrlSuccess('Failed to copy!');
        }
    };

    const loadData = async () => {
        try {

            let weblinkGroups = await cecSdk.weblinkGroup().getWeblinkGroups();
            setWeblinkGroups(weblinkGroups);

            //let appData = await aecSdk.connection().getAppConnection({"ShopUrl": localStorage.getItem('shopUrl'), "Password": localStorage.getItem('token')});

            let connectionType = "a8f55691-9981-4b7e-9132-26e836dc2153";
            setDefaultConnectionType(connectionType);
            setValues({
				connectionDetails: {"ShopUrl": localStorage.getItem('shopUrl'), "Password": localStorage.getItem('token'), "SharedSecret": localStorage.getItem('sharedSecret'), "ApiKey": localStorage.getItem('clientId')},
				connectionType: connectionType,
                name: localStorage.getItem('connectionName') ? localStorage.getItem('connectionName') : '',
                groupCode: localStorage.getItem('groupCode') ? localStorage.getItem('groupCode') : '',
                config: localStorage.getItem('connectionConfig') ? JSON.parse(localStorage.getItem('connectionConfig')) : {},
			});

            let connectionTypeResponse= await aecSdk.connectionType().getConnectionType(connectionType);
            setDefaultResources(connectionTypeResponse.response);

        } catch (error) {
            setError(error.message);
        }

        setRequesting(false);
    };

    const handleOnInputChange = (e) => {
        setValues(set({ ...values }, e.target.name, e.target.value));

        setOnChangedConnectionType(e.target.value);
    };

    const chosenConnectionType = props.connectionTypes[defaultConnectionType];
	const chosenConnectionTypeFieldsMarkup =
		chosenConnectionType &&
		map(chosenConnectionType.default_connection_config, (v, k) => {
			if(k.toUpperCase()=="SHOPURL") {
                return (
					<ConnectionInputRow
						key={k}
						k={k}
						connectionTypeCode={chosenConnectionType.code}
						label={v}
						prefix='connectionDetails.'
						value={shopUrl!=null? shopUrl : values.connectionDetails[k]}
						handleOnChange={handleOnInputChange}
					/>
				);
			} else if(k.toUpperCase()=="PASSWORD") {
				return (
					<ConnectionInputRow
						key={k}
						k={k}
						connectionTypeCode={chosenConnectionType.code}
						label={v}
						prefix='connectionDetails.'
						value={accessToken!=null? accessToken : values.connectionDetails[k]}
						handleOnChange={handleOnInputChange}
					/>
				);
			} else if(k.toUpperCase()=="APIKEY") {
				return (
					<ConnectionInputRow
						key={k}
						k={k}
						connectionTypeCode={chosenConnectionType.code}
						label='Client Id'
						prefix='connectionDetails.'
						value={apiKey!=null? apiKey : values.connectionDetails[k]}
						handleOnChange={handleOnInputChange}
					/>
				);
			} else if(k.toUpperCase()=="SHAREDSECRET") {
				return (
					<ConnectionInputRow
						key={k}
						k={k}
						connectionTypeCode={chosenConnectionType.code}
						label={v}
						prefix='connectionDetails.'
						value={sharedSecret!=null? sharedSecret : values.connectionDetails[k]}
						handleOnChange={handleOnInputChange}
					/>
				);
			} else {
				return (
					<ConnectionInputRow
						key={k}
						k={k}
						connectionTypeCode={chosenConnectionType.code}
						label={v}
						prefix='connectionDetails.'
						value={values.connectionDetails[k]}
						handleOnChange={handleOnInputChange}
					/>
				);
		    }
		});

    const onSubmitForm = async (e) => {
		e.preventDefault();

		if (props.beforeSubmit) {
			props.beforeSubmit(values);
		}

        setSaving(true);

		try {
			//let response = await props.saveConnection(null, values);
            let response = await aecSdk.connection().createAppConnection(null, values);

            if(response.status == 200) {
                window.location.href = "/connections/"+response.response.id;
                props.successNotice('Saved');
            } else {
                props.successNotice('Saved');
            }
		} catch (error) {
            //
		}

		if (props.afterSubmit) {
			props.afterSubmit();
		}

        setSaving(false);
	};

    if (requesting) {
        return (
            <Main>
                <Stack space='large'>
                    <Navigation section='general' />
                    <AnnotatedSectionSkeleton />
                </Stack>
            </Main>
        );
    }

    return (
        <Main>
            <Stack space='large'>
                <Navigation section='general' />
                <Box paddingTop='xxlarge' paddingBottom='xxlarge'>
                    <Box display='flex' justifyContent='spaceBetween' alignItems='center' paddingBottom='xlarge'>
                        <Heading level='1'>App</Heading>
                        <ButtonGroup>
                            <Button disabled={saving} type="submit" form='create-connection-form'>
                                {saving ? (
                                    <div>
                                        Saving <JumpingDots />
                                    </div>
                                ) : (
                                    'Save'
                                )}
                            </Button>
                        </ButtonGroup>
                    </Box>
                    <Divider />
                </Box>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Api Config'
                            description='Enter your api details to allow us to communicate with your Shopify.'
                        />
                        <AnnotatedSection.Content>
                            <Stack space='large'>
                                <Card>
                                    <Card.Section>
                                    <Box>
                                        <form id='create-connection-form' onSubmit={onSubmitForm}>
                                            <Stack space='large'>
                                                <Box>
                                                    <FormLabel>Name:</FormLabel>
                                                    <FormTextInput onChange={handleOnInputChange} name='name' value={values.name} />
                                                </Box>
                                                <Box>
                                                    <FormLabel>Weblink Group Number:</FormLabel>
                                                    <FormSelect onChange={handleOnInputChange} name='groupCode' value={values.groupCode}>
                                                        <option value='' />
                                                        {map(weblinkGroups, ({ name }) =>
                                                            (props.username.toUpperCase() == "GIF3122") ?
                                                            name != '21' ? (
                                                                <option value={name} key={name}>
                                                                    {`${name}`}
                                                                </option>
                                                            ) : (
                                                                ''
                                                            ) : (name != '21') && (name != '24') ? (
                                                                <option value={name} key={name}>
                                                                    {`${name}`} 
                                                                </option>
                                                            ) : (
                                                                ''
                                                            ) ,
                                                        )}
                                                    </FormSelect>
                                                </Box>
                                                <Divider />
                                                {chosenConnectionTypeFieldsMarkup}
                                            </Stack>
                                        </form>     
                                    </Box>
                                    </Card.Section>
                                </Card>
                                <Card>
                                    { (get(values, 'status') == 200) ?
                                    <Card.Section>
                                        <Stack space='large'>
                                            <Box>
                                                <FormLabel>Token:</FormLabel>
                                                <FormTextInput name='stockTradeWebsiteId' value={localStorage.getItem('token')} />
                                            </Box>
                                            <Box>
                                                <Button className="card__section-copy" onClick={() => copyTokenToClipBoard(localStorage.getItem('token'))}>
                                                    <Icon name='FaCopy' /> Copy to clipboard
                                                </Button>{copyTokenSuccess}
                                            </Box>
                                            <Box>
                                                <FormLabel>Shop Url:</FormLabel>
                                                <FormTextInput name='stockTradeWebsiteId' value={localStorage.getItem('shopUrl')} />
                                            </Box>
                                            <Box>
                                                <Button className="card__section-copy" onClick={() => copyUrlToClipBoard(localStorage.getItem('shopUrl'))}>
                                                    <Icon name='FaCopy' /> Copy to clipboard
                                                </Button>{copyUrlSuccess}
                                            </Box>
                                        </Stack>
                                    </Card.Section>
                                    : null
                                    }
                                </Card>
                            </Stack>
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                    <AnnotatedSection>
						<AnnotatedSection.Annotation
							title='Resources'
							description='Select which resources will be sent to your eCommerce platform.'
						/>
						<AnnotatedSection.Content>
							<Stack space='large'>
								<Card>
									<Card.Header heading='Select from available resources.' />
									<Card.Section>
                                       {localStorage.getItem('connectionConfig') ?
										(<SelectResources
                                            defaultResources={defaultResources}
                                            defaultValues={localStorage.getItem('connectionConfig')}
											onChange={(newValues) => {
												setValues({
													...values,
													config: {
														...values.config,
														resources: newValues,
													},
												});
											}}
										/>) : (<SelectResources
                                            defaultResources={defaultResources}
											onChange={(newValues) => {
												setValues({
													...values,
													config: {
														...values.config,
														resources: newValues,
													},
												});
											}}
										/>)}
									</Card.Section>
								</Card>

							</Stack>
						</AnnotatedSection.Content>
					</AnnotatedSection>
                </Stack>
            </Stack>

        </Main>
    );
};

export default connect(
    (state) => ({
        connectionTypes: getAllConnectionTypes(state),
        username: getCurrentUsername(state),
    }),
    {
        requestConnection,
        requestConnectionTypes,
        saveConnection,
        successNotice,
        errorNotice,
    },
)(CreateConnection);
